// routes
import * as ROUTES from '../../../constants/routes';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
};

const navConfig = [
  {
    subheader: 'overview',
    items: [{ title: 'dashboard', path: ROUTES.PATH_ADMIN.root, icon: ICONS.dashboard }],
  },
  {
    subheader: 'people',
    items: [
      {
        title: 'users',
        path: ROUTES.PATH_ADMIN.users.root,
        icon: ICONS.user,
        children: [
          { title: 'parents', path: ROUTES.PATH_ADMIN.users.parent },
          { title: 'children', path: ROUTES.PATH_ADMIN.users.children },
        ],
      },
      {
        title: 'otps',
        path: ROUTES.PATH_ADMIN.otps.root,
        icon: ICONS.user,
        children: [
          { title: 'onboarding', path: ROUTES.PATH_ADMIN.otps.signp },
          { title: 'password-reset', path: ROUTES.PATH_ADMIN.otps.password_reset },
        ],
      },
    ],
  },
  {
    subheader: 'money',
    items: [
      {
        title: 'transactions',
        path: ROUTES.PATH_ADMIN.transactions.root,
        icon: ICONS.analytics,
      },
      {
        title: 'wallet',
        path: ROUTES.PATH_ADMIN.wallet.root,
        icon: ICONS.banking,
        children: [
          { title: 'parents', path: ROUTES.PATH_ADMIN.wallet.parent },
          { title: 'children', path: ROUTES.PATH_ADMIN.wallet.children },
          { title: 'students', path: ROUTES.PATH_ADMIN.wallet.students },
        ],
      },
      {
        title: 'earnings',
        path: ROUTES.PATH_ADMIN.earnings.root,
        icon: ICONS.banking,
        children: [
          { title: 'missions', path: ROUTES.PATH_ADMIN.earnings.missions },
          { title: 'daily bonuses', path: ROUTES.PATH_ADMIN.earnings.dailyBonuses },
          { title: 'referral rewards', path: ROUTES.PATH_ADMIN.earnings.referralRewards },
          { title: 'analytics', path: ROUTES.PATH_ADMIN.earnings.analytics },
        ],
      },
    ],
  },
  {
    subheader: 'content',
    items: [
      {
        title: 'course',
        path: ROUTES.PATH_ADMIN.courses.root,
        icon: ICONS.booking,
        children: [
          { title: 'courses', path: ROUTES.PATH_ADMIN.courses.root },
          { title: 'category', path: ROUTES.PATH_ADMIN.courses.category },
          { title: 'sections', path: ROUTES.PATH_ADMIN.courses.sections },
          { title: 'lessons', path: ROUTES.PATH_ADMIN.courses.lessonsCourses },
        ],
      },
    ],
  },
  {
    subheader: 'growth',
    items: [
      {
        title: 'growth retention',
        path: ROUTES.PATH_ADMIN.growthRetention.root,
        icon: ICONS.analytics,
        children: [
          { title: 'kit downloads', path: ROUTES.PATH_ADMIN.growthRetention.kitDownloads },
        ],
      },
      {
        title: 'esap',
        path: ROUTES.PATH_ADMIN.esap.root,
        icon: ICONS.user,
        children: [
          { title: 'ambassadors', path: ROUTES.PATH_ADMIN.esap.ambassadors },
          { title: 'payouts', path: ROUTES.PATH_ADMIN.esap.payouts },
          { title: 'leaderboard', path: ROUTES.PATH_ADMIN.esap.leaderboard },
        ],
      },
    ],
  },
];

export default navConfig;
